module.exports = __webpack_public_path__ + "assets/img/erweima.30edc6be.png";